import { Schema } from '@effect/schema';
import { Usd } from '@silo/types';

export type SiloTokenPriceBody = typeof SiloTokenPriceBody.Type;

export const SiloTokenPriceBody = Schema.Struct({
  priceUsd: Usd,
});
